import { AnalyticsState } from "../../redux_store/analytics/models";
import { AnalyticsType } from "./model";

export const preCartUpsellPayload = (state: AnalyticsState): AnalyticsType => {
  return {
    product_id: state.productId,
    product_name: state.productName,
    product_category: state.productCategory,
    product_quantity: state.productQuantity,
    upsell_product_id: state.upsellProductId,
    did_add_to_cart: state.didAddToCartUpsell,
    isUpsellPreCart: state.isUpsellPreCart,
  };
};
